import { createFileRoute } from "@tanstack/react-router";
import { SiteFooter, SiteHeader } from "@/components/site-chrome";

const EMAIL = "arinotdev@gmail.com";

export const Route = createFileRoute("/kontak")({
  head: () => ({
    meta: [
      { title: "Kontak — jasasebar.com" },
      { name: "description", content: "Hubungi tim jasasebar.com untuk pertanyaan, kerja sama, atau laporan listing." },
      { property: "og:title", content: "Kontak — jasasebar.com" },
      { property: "og:description", content: "Cara menghubungi tim jasasebar.com." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://jasasebar.com/kontak" }],
  }),
  component: ContactPage,
});

function ContactPage() {
  return (
    <div className="min-h-screen">
      <SiteHeader />
      <main className="mx-auto max-w-3xl space-y-5 px-4 py-12 text-sm leading-relaxed">
        <h1 className="font-display text-3xl font-semibold">Kontak</h1>
        <p>Kami senang mendengar dari Anda. Hubungi kami untuk:</p>
        <ul className="list-disc space-y-1 pl-5">
          <li>Pertanyaan seputar pendaftaran listing dan pembayaran promosi</li>
          <li>Laporan listing yang mencurigakan atau melanggar aturan</li>
          <li>Kerja sama, konten bersponsor, dan media</li>
        </ul>
        <p>
          Email:{" "}
          <a href={`mailto:${EMAIL}`} className="font-medium underline">
            {EMAIL}
          </a>
        </p>
        <p className="text-muted-foreground">Kami biasanya membalas dalam 1–2 hari kerja.</p>
      </main>
      <SiteFooter />
    </div>
  );
}
